// cards.js (shim)
// Compat: l'app utilise app.js pour charger cards.json.
window.BULLE_CARDS_SHIM_LOADED = true;
